// How a date is written down in the journal.
//
// A journal is read by the day, not by the date. "August 20" tells you when something happened only
// if you already remember what that week looked like; "Thursday, August 20" tells you what kind of
// day it was, which is usually the thing being remembered. So the weekday leads, everywhere an
// entry's own date is shown.
//
// Locale-aware rather than hand-assembled: `toLocaleDateString` puts the parts in the order the
// reader's language expects, so this stays "Thursday, August 20, 2026" in en-US and reorders itself
// elsewhere instead of producing something subtly wrong.

/** "Thursday, August 20, 2026" — for the composer header and anywhere an entry states its own date. */
export function longDate(date: Date): string {
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * "Thu, Aug 20, 2026" — the same information where a full date would not fit, such as a gallery
 * tile or a chip. Abbreviated rather than dropping the weekday, so the day of the week is never the
 * part that gets lost.
 */
export function shortDate(date: Date): string {
  return date.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
